import { render, staticRenderFns } from "./M4.vue?vue&type=template&id=5982bd63"
import script from "./M4.vue?vue&type=script&lang=js"
export * from "./M4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports